import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SubmittalsProductsRoutingModule } from './submittals-products-routing.module';
import { SubmittalsProductsComponent } from './submittals-products.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SubmittalsProductsComponent],
  imports: [
    CommonModule,
    SubmittalsProductsRoutingModule,
    SharedModule,
    TranslateModule,
    ModalModule
  ]
})
export class SubmittalsProductsModule { }
